// extracted by mini-css-extract-plugin
module.exports = {"matchScoreTag":"_2Hf4F4"};